import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface LayoutProps {
  children: ReactNode;
  transparentNav?: boolean;
}

export default function Layout({ children, transparentNav = false }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar transparent={transparentNav} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}